import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { API_URL, FILE_URL } from '@core/constants/endpoints';
import { AulaState } from '@core/types/state';
import { getMaterialPlacementLtiProviders } from '@core/selectors/lti';

import AulaEditorWithAnalytics from '../../../common/AulaEditor/AulaEditorWithAnalytics';

type Props = {
  content: any;
  correlationId?: string;
};

const PreviewContent = ({ content, correlationId }: Props) => {
  const state = useSelector((s: AulaState) => s);

  const spaceId = state.classRoom?.current;
  const accessToken = state.accessTokens?.[spaceId]?.token;
  const institution = state.institution?.general?.institution;

  const editorConfig = useMemo(
    () => ({
      accessToken,
      spaceId,
      institution,
      filesUrl: FILE_URL(),
      apiUrl: API_URL(),
      userId: state.user?.userId,
      materialId: 'preview',
      ltiProviders: getMaterialPlacementLtiProviders(state),
      correlationId,
      itemId: 'preview',
      itemType: 'material',
    }),
    [accessToken, spaceId, institution, correlationId, state]
  );

  return (
    <AulaEditorWithAnalytics
      // @ts-ignore
      config={editorConfig}
      editorState={content}
      readOnly
      type="material"
      placeholder=""
      isAssignmentsEnabled={false}
      cursorPosition="start"
      correlationId={correlationId}
      onChange={() => {}}
    />
  );
};

export default PreviewContent;
